<template>

  <div id="algolia-content-container home-page" class="padding-fix relative clearfix home-page">
<!-- DESKTOP IMAGE SLIDER -->
    <div v-if="showSlider && !this.isMobile" class="tr-top-banner"
         v-bind:style="{ 'background-image': 'url(https://restapi.turkishrestaurant.com/images/contents/74/202310/6b01934ff9490bb7489eb071ec9faf3f.webp)' }">
      <div style="z-index: 999"><h1 class="home">Best Turkish Restaurants </h1></div>
    </div>
<!--    <div v-if="showSlider && !this.isMobile">
      <swiper id="swiper-wrapper" :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" >

        <swiper-slide v-for="(slide, index) in contents" :key="index">

          <vx-card class="p-0 overflow-hidden">
            <div class="swipe-image-wrapper  bg-white flex items-center justify-center cursor-pointer product-image"
                 v-bind:style="{ 'background-image': 'url(' + slide.contentImageUrl + ')' }">
            </div>
            <div class="p-absolute bg-filter"></div>
            <div class="description-wrapper">
              <span v-if="showSlideContent" class="slider-text">{{slide.name}}</span>
              <span v-if="showSlideContent" class="slider-text">{{slide.shortContent}}
              </span>
            </div>
          </vx-card>
        </swiper-slide>
      </swiper>
    </div>-->

    <div v-if="isMobile">
      <cities-map :deliverto="deliveryAddress" @searchPerformed="handleSearch" />
    </div>
    <!--
    <div v-if="isMobile" class="main-page-mobile-slider">
      MOBILE TEXT SLIDER
      <swiper id="swiper-wrapper" :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" >

        <swiper-slide>
<h2>YOUR FAVORITE<br>TURKISH RESTAURANT</h2>
        </swiper-slide>
        <swiper-slide>
<h2>TRADITIONAL<br>TURKISH RESTAURANTS</h2>
        </swiper-slide>
        <swiper-slide>
<h2>TRUE<br>TURKISH FLAVORS</h2>
        </swiper-slide>
      </swiper>
    </div>-->
    <!-- GRID VIEW -->
    <tabs-all-new></tabs-all-new>
    <div v-if="showRestofThePage">
      <h3 class="text-primary mt-4" >Restaurant Videos</h3>
      <video-content-pages :videos="videos" class="mt-4"/>
    </div>

    <div class="about-row col-rev-mob catering-box">

      <div class="about-col">
        <div>

          <h2>Looking For Halal Restaurants Near Me </h2>
          <p>
            Exploring halal food options can be exciting. If you are looking for halal restaurants near you, you are in the right place! Check out our flavor map to discover halal restaurants.
          </p>

          <a @click="$router.push({path: '/cities-map'})" ><div class="claim-button mt-2" role="button">Discover Halal Dining Options</div></a>
        </div>
      </div>
      <div class="about-col img halal">
      </div>
    </div>
    <div v-if="hideObject" @click="$router.push({path: '/cities-map'})" class="home-float-button">
      <h3>Find Your Favorite Turkish Restaurant By state</h3>
            </div>
  </div>
</template>

<script>
import TabsAllNew from '../tabs/components/TabsAllNew'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import SearchBar from '../../../layouts/components/navbar/components/SearchBar'
import PageContentPages from './components/PageContentPages'
import BlogContentPages from '../blog/components/BlogContentPages'
import VideoContentPages from './components/VideoContentPages'
import CitiesMap from '../blog/CitiesMap'

export default {
  components: {
    SearchBar,
    TabsAllNew,
    swiper,
    swiperSlide,
    PageContentPages,
    VideoContentPages,
    BlogContentPages,
    CitiesMap
  },
  metaInfo () {
    return {
      title: 'Best Turkish Restaurants -  Mediterranean Halal Cuisine',
      titleTemplate: '%s',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Turkish restaurant near me. Turkish Restaurant is a unique portal where you can find the most delicious traditional Turkish dishes of the United States.'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'Turkish Mediterranean Cuisine'
        }
      ]
    }
  },
  data () {
    return {
      // Filter Sidebar
      hideObject:true,
      isFilterSidebarActive: true,
      clickNotClose: true,
      refresh: false,
      showRestofThePage: false,
      showSlideContent: true,
      videos: [
        'OxvX8jk9LME',
        'eA5tOz9Ms9I',
        'fHFoTswcff4'
      ],
      numericItems: [
        { label: 'All' },
        { label: '<= $10', end: 10 },
        { label: '$10 - $100', start: 10, end: 100 },
        { label: '$100 - $500', start: 100, end: 500 },
        { label: '>= $500', start: 500 }
      ],
      showSlider: true,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: (this.isMobile) ? 0 : 30,
        slidesPerGroup: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        },
        speed: 1500,
        loop: true,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      algoliaCategories: [
        'hierarchicalCategories.lvl0',
        'hierarchicalCategories.lvl1',
        'hierarchicalCategories.lvl2',
        'hierarchicalCategories.lvl3'
      ]
    }
  },
  computed: {
    scrollY () {
      return this.$store.state.scrollY
    },
    toValue () {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max
      ]
    },
    // GRID VIEW
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    },
    windowWidth () { return this.$store.state.windowWidth },
    isMobile () {
      return this.$store.state.api.isMobile
    },
    isInited () {
      return localStorage.getItem('isInited') === 'true'
    },
    isLoggedIn () {
      return this.$store.state.api.token_valid
    },
    showSearch () {
      return this.$store.state.api.showSearch
    },
    deliveryAddress () {
      return this.$store.state.api.deliveryAddress
    },
    contents () {
      return this.$store.state.api.contents
    },
    currentUser () {
      return this.$store.state.api.currentUser
    }
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    },
    /*deliveryAddress (val) {
    },*/
    scrollY () {
      if (this.scrollY < -1) {
        this.showRestofThePage = true
      }
    }
  },
  methods: {
    getContentList () {
      const payload = {
        contentType: 'slide',
        isHome: 1,
        page:'1',
        limit:'20'
      }

      this.$store.dispatch('api/contentList', payload)
        .then(() => {
        })
        .catch(error => {
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },

    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }

    },

    // GRID VIEW - ACTIONS
    toggleFilterSidebar () {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart (item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
    }
  },
  created () {
    this.setSidebarWidth()
    if (this.contents.length === 0) {
      this.getContentList()
    }
  },
  destroyed () {
    this.$store.commit('api/SET_SHOW_SEARCH', false)
  },
  mounted () {
  },
  beforeMount () {
    this.$store.commit('api/SET_SHOW_SEARCH', true)
    this.$store.commit('TOGGLE_IS_SIDE_MENU_ACTIVE', false)
    this.$store.dispatch('updateSideMenuWidth', 'no-nav-menu')
    //this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    //this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap');
.link-box{
  width:100%;
  padding:20px 0;
  .link-box-row{
    display:flex;
    gap:20px;
    .link-box-col{
      flex-basis:33%;
      display:flex;
      flex-direction:column;
      align-items: center;
      border-radius: 7px;
      box-shadow:0px 3px 5px 1px rgba(0,0,0,0.1);
      padding:10px;
      .link-image{
        img{
          width:100%;
          max-width:100%;
        }
      }
      .link-icon{
        font-size:42px;
        a{
        color:#ff2400;
        }
      }
      .link-title{
        font-size:22px;
        font-weight: 900;
        a{
        color:#000;
        }
      }

    }
  }
}
.about-row{
  display:flex;
  margin-top:20px;
 }
 .about-col{
  width:50%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap:20px;
  .claim-button{
    font-size:22px;
  }
  h2{
    text-align: left;
    margin-bottom:5px;
    font-size:52px;
  }
  p{
    font-size:16px;
    padding-right:15px;
  }
 }
 .about-col.img{
  background-size:cover;
  height: 300px;
 }
 .catering{
  background-image: url('../../../../public/image/catering.webp');
 }
 .halal{
  background-image: url('../../../../public/image/halal_restaurant.jpg');
 }
 .catering-box{
  box-shadow:0px 0px 10px 5px rgba(0,0,0,0.1);
  padding:20px;
  border-radius: 3px;
  border-bottom:2px dashed #f24405;
  border-top:2px dashed #f24405;
 }
@media (max-width:768px){
  .about-col {
    width:100%;
    h2{
      font-size:24px;
    }
    &.img{
      margin-bottom:10px;
    }
  }
  .about-row{
    flex-direction: column;
  }
  .col-rev-mob{
    flex-direction: column-reverse;
  }
  .link-box{
  .link-box-row{
    flex-direction: column;
    .link-box-col{
      flex-basis:00%;
    }
  }
}
}
.desktop-off {
  display:none;
}
.tr-shorts-cont{
  width:100%;
  padding:20px;
}
.tr-shorts-row{
  display:flex;
  flex-wrap: wrap;
  margin-bottom:50px;
}

.tr-shorts-col {
  img{
    max-width:100%;
  }
}
.tr-shorts-col.with-text{
  h2{
    font-size:40px;
    font-weight: 900;
    margin-bottom:20px;
  }
  p{
    font-size:22px;
    color:#333;
  }
  width:60%;
  display:flex;
  flex-direction:column;
  justify-content: center;
  padding-right:20px;
}
.tr-shorts-row:nth-child(2) .with-text{
  text-align: right;
  padding-left:20px;
  padding-right:0px;
}
.tr-shorts-col.with-image{
  width:40%;
}
.tr-shorts-row:nth-child(2){
  flex-direction: row-reverse;
}
.tr-featurette {
  width:100%;
  display:flex;
  justify-content: space-between;
  margin-bottom:50px;
}
.tr-featurette-column{
  width:calc(33% - 10px);
}
.tr-featurette-icon {
    margin:0 auto;
  width:150px;
}
.tr-featurette-text {

  h2{
    font-size:24px;
    font-weight:bold;
    margin-bottom:20px;
  }
  text-align:center;
  font-weight: bold;
  font-size:19px;
  display:flex;
  justify-content: center;
  flex-wrap: wrap;
}
.tr-featurette-button {
  margin-top:20px;
  padding:5px 10px;
  width: max-content;
  background-color:#ff2400;
  color:#fff;
  cursor:pointer;
}
@media (max-width:768px){
  .mobile-off {
    display:none;
  }
  .desktop-off {
    display:block;
    margin-top:20px;
  }
  .tr-shorts-cont{
    padding:20px 0 0 0;
  }
  .tr-shorts-col.with-image, .tr-shorts-col.with-text{
    width:100%;
  }
  .tr-shorts-col.with-text{
  h2{
    font-size:22px;
    font-weight: 900;
    margin-bottom:15px;
  }
  p{
    font-size:16px;
    color:#333;
    margin-bottom:15px;
  }
  display:flex;
  flex-direction:column;
  justify-content: center;
  padding-left:0px;
}
.tr-shorts-row:nth-child(2) .with-text{
  text-align: left;
  padding-left:0;
  padding-right:0;
}
  .tr-featurette-column{
  width:100%;
}
.tr-featurette {
  flex-direction: column;
}
}
  .mobile .content-area__content {
    max-width: 100%;
    padding:0px 10px!important;
  }

  .swiper-container {
    overflow: hidden;
    position: relative;
    margin-bottom:20px;
  }
  .home-page {


    .bg-filter {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
    }
    .swipe-image-wrapper {
      width: 100%;
      height: 470px;
      background-size:cover;
      background-position: center;
    }
    #algolia-instant-search-demo {
      .algolia-header {
        .algolia-filters-label {
          width: calc(260px + 2.4rem);
        }
      }

      #algolia-content-container {

        .vs-sidebar {
          position: relative;
          float: left;
        }
      }

      .algolia-search-input-right-aligned-icon {
        padding: 1rem 1.5rem;
      }

      .algolia-price-slider {
        min-width: unset;
      }

      .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
        min-width: 50%;
      }

      .item-view-secondary-action-btn {
        min-width: 50%;
      }
    }

    .theme-dark {
      #algolia-instant-search-demo {
        #algolia-content-container {
          .vs-sidebar {
            background-color: #10163a;
          }
        }
      }
    }

    @media (min-width: 992px) {
      .vs-sidebar-rounded {
        .vs-sidebar {
          border-radius: .5rem;
        }

        .vs-sidebar--items {
          border-radius: .5rem;
        }
      }
    }

    @media (max-width: 992px) {
      #algolia-content-container {
        .vs-sidebar {
          position: absolute !important;
          float: none !important;
        }
      }
    }

    .splide__slide img{
      border-radius: 25px;
    }
    .splide__slide .image-wrapper {
      margin: 0 auto;
      padding: 30px 0px;
    }
    .splide__slide .image-with-bg {
      width: 100%;
      height: 300px;
      margin: 0 auto;
      max-height: 300px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: right;
    }
    .splide__slide__container{
      border-radius: 25px;
    }
    .items-grid-view .vx-col {
      padding: 1rem 1rem 1rem 0;
    }
    .mid-weight {
      font-weight: 500;
    }
    .swiper-wrapper .vx-card .vx-card__body {
      padding: 0 !important;
    }
    .swiper-wrapper .description-wrapper {
      position: absolute;
      top: 75%;
      left: 0;
      transform: translate(0%, -75%);
      display:flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap:10px;
    }
    .swiper-button-next {
      right: 15px;
    }
    .swiper-button-prev {
      left: 15px;
    }
    .swiper-button-prev, .swiper-button-next {
      margin-top: 0;
      cursor: pointer;
      transform: scale(.5);
      background: white;
      color: #626262;
      border-radius: 6px;
      padding: 35px 30px;
      top: calc(235px - var(--swiper-navigation-size)/2);
    }
    .slider-text{
  background-color:rgba(255,255,255,0.8);
  color:#ff6a1e;
  font-weight:900;
  font-size:72px;
  display:block;
  align-self:flex-start;
  padding:0px 30px;
  font-family: 'Archivo Black', sans-serif;

}
    h1.home{
  background-color:rgba(255,255,255,0.8);
  color:#ff6a1e;
  font-weight:900;
  font-size:72px;
  display:block;
  align-self:flex-start;
  padding:0px 30px;
  font-family: 'Archivo Black', sans-serif;

}

  }


  .mobile {
    .home-page {

      .items-grid-view .vx-col {
        padding-right: 0;
      }
      .swiper-button-prev {
        background: white;
        color: black;
        left: 0px;
      }
      .swiper-button-next {
        background: white;
        color: black;
        right: 0px;
      }
    }
  }
  @media (max-width:768px){
    .home-page {
    .swipe-image-wrapper {
      width: 100%;
      height: 200px;
      background-size:cover;
      background-position: center;
    }
    .swiper-button-prev, .swiper-button-next {
      margin-top: 0;
      cursor: pointer;
      transform: scale(.5);
      background: white;
      color: #626262;
      border-radius: 6px;
      padding: 35px 30px;
      top: calc(90px - var(--swiper-navigation-size)/2);
    }
    }
    .trlistinfo p {
      font-size:9px;
    }
    .deals-title{
      font-size:21px;
      padding-left: 11px;
      margin-bottom: -15px !important;
    }
  }
  .main-page-mobile-slider{
    background-color:#f5f5f5;
    padding:30px 0px;
    .swiper-wrapper{
      display:flex;
      align-items: center;
      h2{
        text-align: center;
        font-weight: 900;
        font-size:32px;
        color:#333;
      }
    }

  }
</style>
